<div
  class="border border-dashed border-outline dark:border-outline-darkmode self-stretch p-6 rounded-lg inline-flex flex-col justify-center items-center gap-3 w-full"
>
  <div class="self-stretch flex flex-col justify-start items-center gap-1">
    <div
      class="self-stretch text-center justify-start text-on-surface dark:text-on-surface-darkmode text-sm font-semibold leading-5"
    >
      {{ 'cockpit.locations.page.noLocationsTitle' | transloco }}
    </div>
    <div
      class="self-stretch text-center justify-start text-on-surface-subtle dark:text-on-surface-subtle-darkmode text-sm font-normal leading-5 max-w-xs m-auto"
    >
      {{ 'cockpit.locations.page.noLocationsSubtitle' | transloco }}
    </div>
  </div>
  <div class="flex justify-start items-center gap-3">
    <ui-button mode="outlined" (click)="clickAdd.emit()">
      <ng-icon slot="start" name="heroPlus" size="20" class="!block" />
      {{ 'cockpit.locations.page.addLocationButton' | transloco }}
    </ui-button>
  </div>
</div>
